import type { ColDef } from '@ag-grid-community/core';
import type { AggregateReportConfig, ReportData } from '../report-viewer/report-viewer.model';

/**
 * Column Definitions for Battery Health by OU Report
 */
export const BATTERY_HEALTH_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Normal',
    field: 'normal',
    width: 150,
    cellClass: 'text-center',
    headerClass: 'text-center battery-normal-header',
  },
  {
    headerName: 'Replace Soon',
    field: 'replaceSoon',
    width: 150,
    cellClass: 'text-center',
    headerClass: 'text-center battery-replacesoon-header',
  },
  {
    headerName: 'Replace Now',
    field: 'replaceNow',
    width: 150,
    cellClass: 'text-center',
    headerClass: 'text-center battery-replacenow-header',
  },
  {
    headerName: 'Unknown',
    field: 'unknown',
    width: 150,
    cellClass: 'text-center',
    headerClass: 'text-center battery-unknown-header',
  },
];

/**
 * Configuration for Battery Health by OU aggregate report
 */
export function createBatteryHealthReportConfig(data: unknown[]): ReportData {
  const aggregateConfig: AggregateReportConfig = {
    columns: BATTERY_HEALTH_COLUMN_DEFS,
    groupFields: ['ouPath'],
    aggregationField: 'normal', // Used for tree grouping, actual values come from individual fields
    autoGroupColumnName: 'OU Path',
    data,
  };

  return {
    type: 'battery-health',
    data,
    aggregateConfig,
  };
}
